class BackgroundTaskService {
  private activeTasks = new Set<string>();
  private taskCallbacks = new Map<string, (status: 'started' | 'completed' | 'error') => void>();

  /**
   * Enregistre une tâche en arrière-plan
   */
  startTask(taskId: string, description: string, callback?: (status: 'started' | 'completed' | 'error') => void): void {
    this.activeTasks.add(taskId);
    if (callback) {
      this.taskCallbacks.set(taskId, callback);
    }
    
    // console.log supprimé
    callback?.('started');
  }

  /**
   * Marque une tâche comme terminée
   */
  completeTask(taskId: string): void {
    if (this.activeTasks.has(taskId)) {
      this.activeTasks.delete(taskId);
      const callback = this.taskCallbacks.get(taskId);
      this.taskCallbacks.delete(taskId);
      
      // console.log supprimé
      callback?.('completed');
    }
  }

  /**
   * Marque une tâche comme échouée
   */
  failTask(taskId: string, error?: any): void {
    if (this.activeTasks.has(taskId)) {
      this.activeTasks.delete(taskId);
      const callback = this.taskCallbacks.get(taskId);
      this.taskCallbacks.delete(taskId);
      
      // console.warn supprimé
      callback?.('error');
    }
  }

  /**
   * Vérifie si des tâches sont en cours
   */
  hasActiveTasks(): boolean {
    return this.activeTasks.size > 0;
  }

  /**
   * Obtient le nombre de tâches actives
   */
  getActiveTaskCount(): number {
    return this.activeTasks.size;
  }

  /**
   * Exécute une tâche avec gestion automatique du statut
   */
  async executeTask<T>(
    taskId: string, 
    description: string, 
    taskFunction: () => Promise<T>,
    callback?: (status: 'started' | 'completed' | 'error') => void
  ): Promise<T> {
    this.startTask(taskId, description, callback);
    
    try {
      const result = await taskFunction();
      this.completeTask(taskId);
      return result;
    } catch (error) {
      this.failTask(taskId, error);
      throw error;
    }
  }
}

export const backgroundTaskService = new BackgroundTaskService(); 
